import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';

import { PasswordStrengthSharedComponent } from './password-strength.component';
import { IconSharedModule } from '../../atoms/icon/icon.module';
import { ProgressBarSharedModule } from '../../atoms/progress-bar/progress-bar.module';
import { PasswordSharedModule } from '../../molecules/password/password.module';

@NgModule({
    declarations: [
        PasswordStrengthSharedComponent
    ],
    imports: [
        CommonModule,
        FormsModule,

        NgbPopoverModule,

        IconSharedModule,
        PasswordSharedModule,
        ProgressBarSharedModule
    ],
    exports: [
        PasswordStrengthSharedComponent
    ]
})

export class PasswordStrengthSharedModule {}
